import { FC, ReactElement, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import toast from "react-hot-toast";
import { postWithoutSign } from "../services/ApiHandler";
import { getReferrer, saveToken } from "../services/CookieHandler";
import { useDisclosure } from "@mantine/hooks";
import { Center, Checkbox, Modal } from "@mantine/core";

export class LoginDialogProps {
  onLogin?: () => void;
  onCancel?: () => void;
  isLogin?: boolean = true;
}

export const LoginDialog: FC<LoginDialogProps> = ({ onLogin, onCancel, isLogin }) => {
  const [isLoginMode, setIsLoginMode] = useState(isLogin);
  const [tosChecked,  setTosChecked] = useState(false);

  function GoogleAuthComponent() {
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID!}>
        <GoogleAuthComponentLogin />
      </GoogleOAuthProvider>
    );
  }

  
  async function loginToSite(token: String) {
    var param = { AccessToken: token };
    var response = await postWithoutSign<string>('GoogleAuth/Login', param);
    if(response.code === 1) {
      saveToken(response.data!);
      toast.success("ログインしました");
      onLogin!();
    } else {
      toast.error(response.message!);
    }
  }

  async function register(token: String) {
    var param = { AccessToken: token, Referrer: getReferrer() };
    var response = await postWithoutSign<string>('GoogleAuth/Register', param);
    if(response.code === 1) {
      saveToken(response.data!);
      // toast.success("ログインしました");
      // onLogin!();
      window.location.href = '/thxarigatoo_accountregistration';
    } else {
      toast.error(response.message!);
    }
  }

  function GoogleAuthComponentLogin() {
    const login = useGoogleLogin({
      onSuccess: (codeResponse) => isLoginMode ? loginToSite(codeResponse.access_token) : register(codeResponse.access_token), // 認証コードを取得
      onError:(ex) => console.log(ex),
      scope: "email openid", // scopeはスペース区切り
    });

    return (
      <div className="mr-4 text-center">
        <button disabled={!tosChecked && !isLoginMode} color="primary" onClick={(e) => login()} className="mx-auto max-w-[300px] flex border py-1 px-2 w-full justify-center">
          <img className="w-[24px] mr-2" src="/images/icons8-google-48.png"></img>
          <span className="text-sm">{ isLoginMode ? 'Googleでログイン' : 'Googleで登録' }</span>
        </button>
      </div>
    );
  }

  return <>
    <div className="w-full sm:w-[800px] text-primary">
      <div className="block sm:flex mb-2">
        { isLoginMode && 
        <div className="sm:min-w-[500px] text-center mt-auto mb-auto pb-8">
          <img src="/images/drop-ai-logo.png" className="w-[120px] inline"></img>
          <div className="text-xl font-bold mt-4 mb-4">アカウントにログイン</div>
          {GoogleAuthComponent()}
          <div className="mt-8">
            <span onClick={() => setIsLoginMode(false) } className="text-sm clickable text-blue-600">アカウントをお持ちではない方はこちら</span>
          </div>
        </div>
        }
        { !isLoginMode && 
        <div className="sm:min-w-[500px] text-center mt-auto mb-auto pb-8">
          <div className="mt-8 mb-2">
            <img src="/images/drop-ai-logo.png" className="w-[120px] inline"></img>
            <div className="text-xl font-bold mt-4 mb-4">アカウントに登録して<br/>
              <span>¥0円</span>
              <span className="text-xs font-normal">(無料)※</span>ではじめる</div>
            <div className="flex justify-center items-center mt-8">
              <Checkbox
                  color="#0909FF"
                  checked={tosChecked}
                  label="利用規約に同意する"
                  onChange={(event) => setTosChecked(event.currentTarget.checked)}></Checkbox>
            </div>
          </div>
          {GoogleAuthComponent()}
          <div className="text-xs mt-4 text-gray-500">
            ※アカウント登録でFreeプランが自動適用されます。<br/>
            Freeプランは無期限で無料利用が可能です。
          </div>
          <div className="text-xs mt-3 mx-auto text-gray-500">
            <ul className="list-disc list-inside text-left w-fit mx-auto">
              <li className="list-none">Freeプラン提供内容</li>
              <li>1日あたりの生成数の上限 4 まで</li>
              <li>広告非表示オプション なし</li>
              <li>同時画像生成数 1 まで</li>
              <li>生成画像の保存期間 30 日間</li>
              <li>詳細画像設定機能 なし</li>
            </ul>
          </div>
          <div className="mt-8">
          <span onClick={() => setIsLoginMode(true) } className="text-sm clickable text-blue-600">アカウントをすでにお持ちの方はこちら</span>
          </div>
        </div>
        }
        <div className={`relative max-h-[200px] sm:max-h-[600px] w-full ${isLoginMode ? '' : 'hidden sm:block'}`}>
          <img src="/images/login-left-image.png" className="object-cover w-full h-[160px] sm:h-[460px] object-top"></img>
          <div className="absolute left-0 right-0 bottom-0 h-[200px] sm:h-[400px] w-full" style={{ background : 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 1) 150%)' }}></div>
        </div>
        
      </div>
    </div>
  </>;

}